// extracted by mini-css-extract-plugin
export var textInput = "_k2-0";